import { useWebinarSubscription } from './useWebinarSubscription'
import { WebinarSubscriptionUI } from './WebinarSubscriptionUI'

export const WebinarSubscriptionPage = () => {
  const props = useWebinarSubscription()

  return <WebinarSubscriptionUI {...props} />
}
